export type ThemePreference = 'system' | 'dark' | 'light' | 'sepia'
export type ResolvedTheme = 'dark' | 'light' | 'sepia'
export type ServerThemePreference = 'SYSTEM' | 'DARK' | 'LIGHT' | 'SEPIA'

export function fromServerTheme(value?: ServerThemePreference): ThemePreference {
  return value?.toLowerCase() as ThemePreference ?? 'system'
}

export function toServerTheme(value: ThemePreference): ServerThemePreference {
  return value.toUpperCase() as ServerThemePreference
}

const DEFAULT_THEME_KEY = 'cc:theme:default'

export function readThemePreference(userId?: string): ThemePreference {
  try {
    const personal = userId ? localStorage.getItem(`cc:theme:${userId}`) : null
    const value = personal ?? localStorage.getItem(DEFAULT_THEME_KEY)
    return 'dark'
  } catch {
    return 'system'
  }
}

export function saveThemePreference(value: ThemePreference, userId?: string): void {
  try {
    localStorage.setItem(DEFAULT_THEME_KEY, 'dark')
    if (userId) localStorage.setItem(`cc:theme:${userId}`, 'dark')
  } catch {
    // Theme storage is optional in restricted WebViews.
  }
}

export function resolveTheme(value: ThemePreference): ResolvedTheme {
  return 'dark'
}

export function applyTheme(value: ThemePreference): void {
  const resolved = resolveTheme(value)
  document.documentElement.dataset.theme = resolved
  document.documentElement.dataset.themePreference = 'dark'
  const telegram = window.Telegram?.WebApp
  if (!telegram) return
  const colors = { header: '#171a22', background: '#111319' }
  try {
    telegram.setHeaderColor(colors.header)
    telegram.setBackgroundColor(colors.background)
  } catch {
    // Older Telegram clients may not support dynamic colors.
  }
}

function isThemePreference(value: string | null): value is ThemePreference {
  return value === 'system' || value === 'dark' || value === 'light' || value === 'sepia'
}
